import { Component, OnInit } from '@angular/core';
declare var jquery: any;
declare var $: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  username = localStorage.getItem('userName');

  constructor() { }

  ngOnInit() {
    // Comentado para teste (16/09/2024)
    // $('.connectedSortable').sortable({
    //   placeholder: 'sort-highlight',
    //   connectWith: '.connectedSortable',
    //   handle: '.box-header, .nav-tabs',
    //   forcePlaceholderSize: true,
    //   zIndex: 999999
    // });
    //
    // $('.connectedSortable .box-header, .connectedSortable .nav-tabs-custom').css('cursor', 'move');

    // $('[data-widget="pushmenu"]').PushMenu('toggle');
  }

}
